var React = require('react');

function Smog (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M624 368H80a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h544a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-480 96H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm416 0H224a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h336a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 144a143.73 143.73 0 0 1 248-99.2A143.18 143.18 0 0 1 352 0c54.8 0 102 31 126.3 76.1A110.53 110.53 0 0 1 528 64a112 112 0 0 1 0 224h-60.1c-22.6 19.7-51.6 32-83.9 32s-61.4-12.3-83.9-32H144A144 144 0 0 1 0 144z","className":"fa-primary","key":2})]);
}

Smog.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Smog;

Smog.default = Smog;
